import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Helmet } from "react-helmet";
import ServiceInclude from "../../component/ServiceInclude";


const MarketingCloud = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Top Salesforce Marketing Cloud Consultant</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content=" "
                />
                <meta
                    name="keywords"
                    content=" "
                />
            </Helmet>

            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Marketing Cloud</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/salesforce/marketing-cloud/marketing-cloud.webp')} alt="" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">

                        <div className="salesforce-service">
                            <p className="prose-lg wow fadeUp">
                                Salesforce Marketing Cloud is a marketing automation platform that helps businesses enhance the effectiveness of their marketing efforts by providing:
                            </p>
                        </div>

                        <div className="sasesforce-benifit">
                            <div className='explore-service text-left'>
                                <h2>Salesforce Implementation Benefits</h2>
                            </div>
                            <div className="row mt-5">
                                <div className="col-md-4">
                                    <div className="benifit-number">
                                        <h3>27% </h3>
                                        <p className="wow fadeUp prose-lg">increase in sales productivity</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="benifit-number">
                                        <h3>30% </h3>
                                        <p className="wow fadeUp prose-lg">increase in sales revenue</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="benifit-number">
                                        <h3>25% </h3>
                                        <p className="wow fadeUp prose-lg">increase in the opportunity win rate</p>
                                    </div>
                                </div>
                                <p className="wow fadeUp prose-lg">With our expertise in Salesforce Marketing Cloud, we offer a range of services, from consulting to ongoing support, designed to help your business maximize the benefits of the software.</p>
                            </div>
                        </div>

                        <div className="contact-shadow top_padding">
                            <div className="row mb-4">
                                <div className="valuation-box">
                                    <div className="col-md-9">
                                        <h3>Taste the Benefits of Your Future Solution!</h3>
                                        <p className="prose-lg wow fadeUp">Request a personalized Salesforce Service Cloud demo and discover how it can benefit YOUR business.</p>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="button_exp mt-5">
                                            <Link to="/contact"><button>Contact us</button> </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Key Tools of Salesforce Marketing Cloud</h2>
                                <p className="wow fadeUp prose-lg text-left"> With Salesforce Marketing Cloud, you get a set of tools intended to cover all marketing needs:</p>
                            </div>

                            <div className="row mt-5">
                                <div className="col-lg-3 col-md-4">
                                    <div className="cloud-item-box">
                                        <p className="prose-lg"><strong>Journey Builder</strong></p>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4">
                                    <div className="cloud-item-box">
                                        <p className="prose-lg"><strong>Email Studio</strong></p>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4">
                                    <div className="cloud-item-box">
                                        <p className="prose-lg"><strong>Audience Studio</strong></p>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4">
                                    <div className="cloud-item-box">
                                        <p className="prose-lg"><strong>Data Studio</strong></p>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4">
                                    <div className="cloud-item-box">
                                        <p className="prose-lg"><strong>Google Marketing Platform</strong></p>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4">
                                    <div className="cloud-item-box">
                                        <p className="prose-lg"><strong>Datorama</strong></p>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4">
                                    <div className="cloud-item-box">
                                        <p className="prose-lg"><strong>Social Studio</strong></p>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4">
                                    <div className="cloud-item-box">
                                        <p className="prose-lg"><strong>Advertising Studio</strong></p>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4">
                                    <div className="cloud-item-box">
                                        <p className="prose-lg"><strong>Mobile Studio</strong></p>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4">
                                    <div className="cloud-item-box">
                                        <p className="prose-lg"><strong>Interaction Studio</strong></p>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4">
                                    <div className="cloud-item-box">
                                        <p className="prose-lg"><strong>Pardot</strong></p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Data Management Tools</h2>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/marketing-cloud/tools-1.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Capturing and processing data with Audience Studio</strong> </p>
                                            <p className="wow fadeUp prose-lg">We begin by introducing Audience Studio because it serves as the central hub for marketing data, which can be leveraged by other marketing tools. It collects and stores data from all customer touchpoints—such as emails, live chats, phone calls, and social media—providing your marketing team with valuable insights into your audience. This data allows for customer segmentation based on various attributes, enabling personalized communication tailored to the interests and needs of specific segments. This data-driven approach is expected to result in more engaged customers and, ultimately, higher revenue. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/marketing-cloud/tools-2.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Gathering insights about customer communication with Interaction Studio </strong> </p>
                                            <p className="wow fadeUp prose-lg"> Interaction Studio captures every customer interaction with your brand in real-time across all touchpoints. Its strength lies in delivering actionable data precisely when it can be most impactful. With Interaction Studio, marketers receive real-time suggestions for the best actions or journeys, tailored to how a customer's interaction with the company is evolving. For instance, it allows marketers to personalize product recommendations during a customer's online shopping journey based on the products they’ve previously browsed.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/marketing-cloud/tools-3.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Reaching new audiences with Data Studio </strong> </p>
                                            <p className="wow fadeUp prose-lg"> Salesforce offers Data Studio, a data-sharing solution that creates a secure environment for data owners and purchasers to connect and exchange information. Essentially, Data Studio functions as a marketplace for second-party data, providing marketers with a unique opportunity to discover new audiences and integrate them into their marketing efforts. For example, a sports retailer could purchase a database of subscribers from an online workout platform and run a targeted campaign offering sportswear to those subscribers.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/marketing-cloud/tools-4.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong> Enhancing Your Marketing Strategies with Google Marketing Platform</strong> </p>
                                            <p className="wow fadeUp prose-lg"> By integrating Google Analytics 360 with Salesforce Marketing Cloud, you can leverage web analytics data to drive your marketing objectives and gain complete visibility into how your marketing efforts influence customer engagement. This integration allows you to go beyond relying solely on sales data to re-engage customers—it enables you to generate marketing insights and create targeted audiences based on their behavior on your website.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/marketing-cloud/tools-5.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>	Doing data-driven marketing with Datorama </strong> </p>
                                            <p className="wow fadeUp prose-lg">The Datorama marketing intelligence platform helps centralize all your marketing data, utilizing AI to extract valuable insights and refine your marketing strategy based on the results of past campaigns. This allows your team to focus on strategic planning and creative thinking, rather than getting caught up in the routine task of data collection.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Communication Tools</h2>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/marketing-cloud/tools-6.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Capturing and processing data with Audience Studio</strong> </p>
                                            <p className="wow fadeUp prose-lg">Email Studio provides extensive functionality covering all the features required to effectively communicate with customers via emails: </p>
                                            <div className="why-listing mt-4 ml-3">
                                                <ul>
                                                    <li className="wow fadeUp prose-lg"> Customer segmentation capabilities</li>
                                                    <li className="wow fadeUp prose-lg"> Dynamic content</li>
                                                    <li className="wow fadeUp prose-lg"> Customizable email templates</li>
                                                    <li className="wow fadeUp prose-lg"> Responsive email design</li>
                                                    <li className="wow fadeUp prose-lg"> Drag-and-drop editor to create an email from content blocks</li>
                                                    <li className="wow fadeUp prose-lg"> Support for A/B testing</li>
                                                    <li className="wow fadeUp prose-lg"> Preview and test</li>
                                                    <li className="wow fadeUp prose-lg"> Email analytics</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/marketing-cloud/tools-7.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Building social media presence with Social Studio </strong> </p>
                                            <p className="wow fadeUp prose-lg">Social Studio allows companies to build effective social media presence. This is how the Studio might be helpful to several departments: </p>
                                            <div className="why-listing mt-4 ml-3">
                                                <ul>
                                                    <li className="wow fadeUp prose-lg">Marketers can create corporate profiles to craft engaging content, promote marketing campaigns, and interact with their audience.  </li>
                                                    <li className="wow fadeUp prose-lg"> At the same time, marketing managers monitor the overall performance, assessing whether the company’s social media efforts are delivering results.</li>
                                                    <li className="wow fadeUp prose-lg"> Sales teams can track posts expressing information requests or purchasing intent, helping them nurture prospects. Similarly, service agents can follow this approach by identifying complaints or negative feedback on social media and proactively reaching out to resolve issues with customers.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/marketing-cloud/tools-8.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Integrating personalized advertising into your marketing strategy with Advertising Studio</strong> </p>
                                            <p className="wow fadeUp prose-lg"> If you’re planning to invest in advertising, Advertising Studio can help boost your ROI. By leveraging customer data stored in Salesforce, your marketing team can deliver targeted content to customers through Google Search and social media platforms like Facebook, Instagram, Twitter, and LinkedIn. For example, in Advertising Studio, you can create upsell ads based on customers' purchase history. This personalized approach increases the likelihood of clicks and drives customers to continue their shopping journey, achieving the desired outcome.</p>
                                            <div className="why-listing mt-4 ml-3">
                                                <ul>
                                                    <li className="wow fadeUp prose-lg"> Send mobile messages and push notifications personalized to different customer segments.</li>
                                                    <li className="wow fadeUp prose-lg"> Deliver transactional notifications and time-sensitive messages like password resets, shipping reminders or order updates to mobile</li>
                                                    <li className="wow fadeUp prose-lg"> Incorporate geofence messages to engage customers instantly when they enter or exit a targeted area. This feature is especially valuable for brick-and-mortar businesses, allowing you to send timely, location-based notifications that capture customers’ attention as they move within a specific vicinity.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/marketing-cloud/tools-9.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Integrating personalized advertising into your marketing strategy with Advertising Studio</strong> </p>
                                            <p className="wow fadeUp prose-lg">If you are going to invest in advertising, this Studio may increase ROI. Leveraging customer data stored in Salesforce, your marketers can advertise relevant content to customers in Google Search and on social media (Facebook, Instagram, Twitter, and LinkedIn). For example, in Advertising Studio, one can create upsell ads tailored to the purchase history of customers. As a result, they are more likely to click and move on to shopping – the aim is achieved.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='explore-heading text-left mt-5'>
                                <h2>Where Data Management and Customer Communication Meet</h2>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/marketing-cloud/tools-10.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Creating customer communication scenarios with Journey Builder</strong> </p>
                                            <p className="wow fadeUp prose-lg">As your customer base grows and you engage more communication channels, achieving data-driven, customer-focused marketing becomes increasingly challenging. This is where marketers can truly benefit from Journey Builder, which allows them to create tailored communication scenarios for different customer segments (defined using data management tools) and engage with them in a timely and effective manner (through customer communication tools). Journeys unfold based on how customers respond to marketing actions. For instance, you can send an offer with product recommendations to new customers a week after their first purchase. The two potential pathways for the journey are:</p>
                                            <div className="why-listing mt-4 ml-3">
                                                <ul>
                                                    <li className="wow fadeUp prose-lg"> Send mobile messages and push notifications personalized to different customer segments.</li>
                                                    <li className="wow fadeUp prose-lg"> Deliver transactional notifications and time-sensitive messages like password resets, shipping reminders or order updates to mobile</li>
                                                    <li className="wow fadeUp prose-lg"> Incorporate geofence messages to engage customers instantly when they enter or exit a targeted area. This feature is especially valuable for brick-and-mortar businesses, allowing you to send timely, location-based notifications that capture customers’ attention as they move within a specific vicinity.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='explore-heading text-left mt-5'>
                                <h2>A B2B Marketing Automation Tool</h2>
                            </div>
                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/marketing-cloud/tools-11.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Building meaningful connection with your B2B audience with Pardot</strong> </p>
                                            <p className="wow fadeUp prose-lg"> Running a B2B business requires a marketing automation tool that caters to its unique needs. Pardot helps align sales and marketing, significantly enhancing lead generation and management. With built-in AI, it automates lead scoring, allowing you to prioritize leads and direct your team’s efforts more effectively.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="Choose-plan-section bottom_padding">
                            <div className='explore-heading text-left'>
                                <h2>Pricing</h2>
                                <p className="wow fadeUp prose-lg text-left">Every business has unique marketing needs, and Salesforce understands this by offering tailored pricing packages for its marketing automation tools.</p>
                            </div>
                            <div className="row top_padding">
                                <p className="prose-lg"><strong>Pardot</strong></p>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Growth</h3>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg"> Meet your fundamental marketing needs with lead generation and management</li>
                                                <li className="wow fadeUp prose-lg"> Add personalized email marketing to engage buyers</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing"><strong>$1,250/month</strong></p>
                                        <p className="prose-md font-italic">(for up to 10,000 contacts, billed annually)</p>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Plus</h3>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg"> Advance marketing personalization</li>
                                                <li className="wow fadeUp prose-lg"> Maximize marketing ROI with powerful analytics and reporting</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing"><strong>$2,500/month </strong></p>
                                        <p className="prose-md font-italic">(for up to 10,000 contacts, billed annually)</p>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Advanced</h3>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg">Get access to Salesforce Einstein AI</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing"><strong>$4,000/month</strong></p>
                                        <p className="prose-md font-italic">(for up to 10,000 contacts, billed annually)</p>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Premium</h3>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg">Use B2B Marketing Analytics Plus for predictive analytics</li>
                                                <li className="wow fadeUp prose-lg">Ensure quick help with Salesforce Premier Support</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing"><strong>$15,000/month</strong></p>
                                        <p className="prose-md font-italic">(for up to 75,000 contacts, billed annually)</p>
                                    </div>
                                </div>
                            </div>

                            <div className="row top_padding">
                                <p className="prose-lg"><strong>Email, Mobile and Web Marketing</strong></p>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Basic</h3>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg">Leverage personalized email marketing</li>
                                                <li className="wow fadeUp prose-lg"> Design content easily with a drag-and-drop editor</li>
                                                <li className="wow fadeUp prose-lg">Seamlessly integrate with Sales and Service Clouds</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing">Starting at<strong>$400/org/month</strong></p>
                                        <p className="prose-md font-italic">(billed annually)</p>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Pro</h3>
                                        <p className="prose-lg">Achieve higher marketing ROI with:</p>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg"> Enhanced customer segmentation</li>
                                                <li className="wow fadeUp prose-lg">Predictive intelligence</li>
                                                <li className="wow fadeUp prose-lg">Expanded automation capabilities </li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing">Starting at<strong>$1,250/org/month </strong></p>
                                        <p className="prose-md font-italic">(billed annually)</p>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Enterprise</h3>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg">Create marketing campaigns using Journey Builder</li>
                                                <li className="wow fadeUp prose-lg">Engage mobile users through Mobile Studio</li>
                                                <li className="wow fadeUp prose-lg">Access the power of Salesforce Einstein AI</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing"><strong>$15,000/month</strong></p>
                                        <p className="prose-md font-italic">(for up to 75,000 contacts, billed annually)</p>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Corporate</h3>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg">- Manage marketing activities across multiple brands, business units, and regions.  </li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing">Starting at<strong>$3,750/org/month</strong></p>
                                        <p className="prose-md font-italic">Pricing available upon request (depends on contact and message volume)</p>
                                    </div>
                                </div>
                            </div>

                            <div className="row top_padding">
                                <p className="prose-lg"><strong>Social Studio</strong></p>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Basic</h3>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg">Focus on brand listening across social media</li>
                                                <li className="wow fadeUp prose-lg">Monitor 2 social accounts</li>
                                                <li className="wow fadeUp prose-lg">Track up to 20K monthly mentions</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing">Starting at<strong> $1,000/org/month</strong></p>
                                        <p className="prose-md font-italic">(billed annually)</p>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Pro</h3>
                                        <p className="prose-lg">Extra</p>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg"> Focus on social engagement</li>
                                                <li className="wow fadeUp prose-lg">Plan and publish content</li>
                                                <li className="wow fadeUp prose-lg">10 social accounts </li>
                                                <li className="wow fadeUp prose-lg">250K monthly mentions</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing">Starting at <strong>$1,250/org/month </strong></p>
                                        <p className="prose-md font-italic">(billed annually)</p>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Extra</h3>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg">Full social automation capabilities</li>
                                                <li className="wow fadeUp prose-lg">20 social accounts</li>
                                                <li className="wow fadeUp prose-lg">1.5M monthly mentions</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing">Starting at <strong>$12,000/org/month</strong></p>
                                        <p className="prose-md font-italic">(billed annually)</p>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Extra</h3>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg">Manage social media marketing across multiple brands, business units, and regions.</li>
                                                <li className="wow fadeUP prose-lg"> 20+ social accounts</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing">Starting at<strong> $40,000/org/month</strong></p>
                                        <p className="prose-md font-italic">(billed annually)</p>
                                    </div>
                                </div>
                            </div>

                            <div className="row top_padding">
                                <p className="prose-lg"><strong>Advertising Studio</strong></p>
                                <div className="col-md-13 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Professional</h3>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg">Power audiences across digital advertising</li>
                                                <li className="wow fadeUp prose-lg">Use your CRM data for advertising</li>
                                                <li className="wow fadeUp prose-lg">Transfer leads from advertising to sales and marketing teams for nurturing</li>
                                                <li className="wow fadeUp prose-lg">Enable Journey Builder Advertising</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing">Starting at<strong> $1,000/org/month</strong></p>
                                        <p className="prose-md font-italic">(billed annually)</p>
                                    </div>
                                </div>
                            </div>

                            <div className="row top_padding">
                                <p className="prose-lg"><strong>Audience Studio</strong></p>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Basic</h3>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg">Collect customer data</li>
                                                <li className="wow fadeUp prose-lg">Build lookalike audiences</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing">Starting at<strong> $18,000/org/month</strong></p>
                                        <p className="prose-md font-italic">(billed annually)</p>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Professional</h3>
                                        <p className="prose-lg">Extra</p>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg"> - Access advanced tools for planning, activation, optimization, personalization, and analytics.</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing">Starting at <strong>$36,000/org/month </strong></p>
                                        <p className="prose-md font-italic">(billed annually)</p>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Multichannel audience</h3>
                                        <p className="prose-lg">Extra</p>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg"> Use Salesforce Einstein AI for deeper segmentation and journey insights</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing">Pricing available upon request </p>
                                    </div>
                                </div>
                            </div>

                            <div className="row top_padding">
                                <p className="prose-lg"><strong>Google Marketing Platform</strong></p>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Google Analytic 360</h3>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg">Use web analytics for marketing activities</li>
                                                <li className="wow fadeUp prose-lg">Message to audiences created in Analytics 360 across marketing channels</li>
                                                <li className="wow fadeUp prose-lg">Get access to Tag Manager 360</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing">Starting at<strong> $12,500/org/month</strong></p>
                                        <p className="prose-md font-italic">(billed annually)</p>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item plan-marketing">
                                        <h3>Google Analytics 360 + Optimize 360</h3>
                                        <div className="why-listing mt-4 ml-3">
                                            <ul>
                                                <li className="wow fadeUp prose-lg">Utilize various testing tools to experiment with different website variations and elements, creating a more engaging user experience.</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center pricing">Starting at <strong> $17,500/org/month </strong></p>
                                        <p className="prose-md font-italic">(billed annually)</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="contact-shadow top_padding">
                            <div className="row mb-4">
                                <div className="valuation-box">
                                    <div className="col-md-9">
                                        <h3>Improve Your Customer Service with Codezix</h3>
                                        <p className="prose-lg wow fadeUp">If your top priority is ensuring customer satisfaction, ScienceSoft's Salesforce services are exactly what you need.</p>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="button_exp mt-5">
                                            <Link to="/contact"><button>Get a free consultation</button> </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Unlock the Full Potential of Salesforce Marketing Cloud with Codezix</h2>
                                <p className="wow fadeUp prose-lg text-left">Buying marketing software is just one step toward successful marketing automation. You may need expert guidance throughout the entire process—from selecting the right solution for your business to ensuring its smooth operation afterward. ScienceSoft is here to assist you with the following marketing automation services:</p>
                            </div>

                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/consulting">
                                            <h3 class="mt-0">Salesforce Consulting</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/implementation">
                                            <h3 class="mt-0">Salesforce Implementation</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud#">
                                            <h3 class="mt-0">Salesforce Migration</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/managed">
                                            <h3 class="mt-0">Salesforce Managed Services</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="contact-shadow top_padding">
                                <div className="row mb-4">
                                    <div className="valuation-box">
                                        <div className="col-md-9">
                                            <h3>Increase the Efficiency of Your Marketing Budget</h3>
                                            <p className="prose-lg wow fadeUp">Don’t hesitate to get better leads, higher conversion and increased marketing ROI.</p>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="button_exp mt-5">
                                                <Link to="/contact"><button>Interested in Salesforce Marketing Cloud</button> </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>


                    </div>
                </div>
            </div >
        </>
    )
}

export default MarketingCloud;